import React from 'react'

export default function Images({ images }) {

  return (
    <React.Fragment>
      {images.length === 2 &&
        <div className="grid grid-cols-1 sm:grid-cols-2 justify-between gap-10 sm:h-56">
          {images.map((image, index) => {
            return <div key={`${index}-${image.url}`} className="w-full  h-56">
              <img className="object-cover w-full h-full rounded-md" src={image.doubled?.url} />
            </div>
          }) }
        </div>
      || images.length === 3 &&
        <div className="grid grid-cols-1 sm:grid-cols-3 justify-between gap-10 sm:h-56">
          {images.map((image, index) => {
            return <div key={`${index}-${image.url}`} className="w-full h-56">
              <img className="object-cover w-full h-full rounded-md" src={image.tripled?.url} />
            </div>
          }) }
        </div>
      || <div></div>
      }
    </React.Fragment>
  )
}